import Styles from "../../styles/report/bodyweight.module.scss";

const BodyWeight = ({ report }) => {
  const sortedReports = Array.isArray(report)
    ? [...report].sort(
        (a, b) =>
          (a?.block ?? Number.MAX_SAFE_INTEGER) -
          (b?.block ?? Number.MAX_SAFE_INTEGER)
      )
    : [];

  const reportsByBlock = new Map(
    sortedReports
      .filter((r) => Number.isFinite(r?.block))
      .map((r) => [r.block, r])
  );

  const blocks = [1, 2, 3, 4];

  const chartData = {
    bodyWeight: {
      title: "Body Weight (kg)",
      data: blocks.map((b) => ({
        label: `Block ${b}`,
        value: reportsByBlock.get(b)?.body?.weight,
        color:
          b === 1
            ? "#666666"
            : b === 2
            ? "#ff8c42"
            : b === 3
            ? "#ffffff"
            : "#BB6307",
      })),
    },
    muscleMass: {
      title: "Muscle Mass (kg)",
      data: blocks.map((b) => ({
        label: `Block ${b}`,
        value: reportsByBlock.get(b)?.body?.muscle,
        color:
          b === 1
            ? "#666666"
            : b === 2
            ? "#ff8c42"
            : b === 3
            ? "#ffffff"
            : "#BB6307",
      })),
    },
    bodyFat: {
      title: "Body Fat (%)",
      data: blocks.map((b) => ({
        label: `Block ${b}`,
        value: reportsByBlock.get(b)?.body?.fat,
        color:
          b === 1
            ? "#666666"
            : b === 2
            ? "#ff8c42"
            : b === 3
            ? "#ffffff"
            : "#BB6307",
      })),
    },
  };

  const maxValue = 100;

  const ChartComponent = ({ title, data }) => {
    return (
      <div className={Styles.chartContainer}>
        <h3 className={Styles.chartTitle}>{title}</h3>
        <div className={Styles.titleLine}></div>
        <div className={Styles.chartContent}>
          <div className={Styles.yAxis}>
            {data.map((item, index) => (
              <div key={index} className={Styles.yLabel}>
                {item.label}
              </div>
            ))}
          </div>
          <div className={Styles.chartArea}>
            <div className={Styles.gridBackground}>
              {/* Vertical grid lines */}
              {[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map(
                (value, index) => (
                  <div
                    key={index}
                    className={Styles.gridLine}
                    style={{ left: `${(value / maxValue) * 100}%` }}
                  ></div>
                )
              )}
            </div>
            <div className={Styles.barsContainer}>
              {data.map((item, index) => {
                const numeric = Number(item.value);
                const widthPct = Number.isFinite(numeric)
                  ? Math.max(0, Math.min((numeric / maxValue) * 100, 100))
                  : 0;
                return (
                  <div key={index} className={Styles.barRow}>
                    <div
                      className={Styles.bar}
                      style={{
                        width: `${widthPct}%`,
                        backgroundColor: item.color,
                      }}
                    ></div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        {/* Move x-axis outside of chartArea to avoid height mismatch */}
        <div className={Styles.xAxis}>
          <span>0</span>
          <span>10</span>
          <span>20</span>
          <span>30</span>
          <span>40</span>
          <span>50</span>
          <span>60</span>
          <span>70</span>
          <span>80</span>
          <span>90</span>
          <span>100</span>
        </div>
      </div>
    );
  };

  return (
    <div className={Styles.bodyweightDashboard}>
      <div className={Styles.chartsGrid}>
        <ChartComponent
          title={chartData.bodyWeight.title}
          data={chartData.bodyWeight.data}
        />

        <ChartComponent
          title={chartData.muscleMass.title}
          data={chartData.muscleMass.data}
        />
        <ChartComponent
          title={chartData.bodyFat.title}
          data={chartData.bodyFat.data}
        />
      </div>
    </div>
  );
};

export default BodyWeight;
